import { Col, Text } from 'components';
import React, { useState, useEffect } from 'react';
import { IScreen } from 'type';
import Store from 'store';
import { useNavFunc } from 'navigation';
import { useDynamicResponsiveValue } from 'quickly-react';
import { ASSETS } from 'assets';
import { COLOR } from 'const';
import { ActivityIndicator, Image } from 'react-native';

const Register: IScreen = () => {
  const { route } = useNavFunc();
  const rV = useDynamicResponsiveValue();
  const { email, otp }: any = route.params || {};
  const [isLoading, setIsLoading] = useState(true);
  const [errorMes, setErrorMes] = useState('');
  const isMobile = rV({ xs: true, md: false });

  const submit = async () => {
    setIsLoading(true);
    setErrorMes('');
    try {
      const res = await Store.Api.User.verifyRegister({
        email,
        verifyCode: otp,
      });
      setIsLoading(false);
      if (res.data && res.data.error) {
        setErrorMes(String(res.data.error));
      } else if (res.data && res.data.success) {
        setErrorMes('');
      } else {
        setErrorMes('Unknown response from server.');
      }
    } catch (err: any) {
      setIsLoading(false);
      setErrorMes(err?.message || String(err));
    }
  };

  useEffect(() => {
    if (email && otp) {
      submit();
    } else {
      setErrorMes('Invalid request');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showSuccess = !!email && !!otp && !isLoading && !errorMes;

  return (
    <Col flex1 middle={!isMobile} p2>
      <Col width={isMobile ? '100%' : '50%'} borderRadius={20} bgMain overflow={'hidden'}>
        <Col
          style={{
            backgroundColor: COLOR.MAIN,
            height: 100,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Image source={ASSETS.LOGO} style={{ width: '65%', height: '100%', marginVertical: 5 }} resizeMode='contain' />
        </Col>
        <Col bgWhite p2 minHeight={160} alignCenter justifyCenter>
          {isLoading ? (
            <Col alignCenter justifyCenter>
              <ActivityIndicator size="large" color={COLOR.MAIN} />
              <Text mt2 muted size={16}>
                Verifying your account, please wait...
              </Text>
            </Col>
          ) : errorMes ? (
            <Col alignCenter justifyCenter>
              <Text mb1 size={18} color={COLOR.RED} fontWeight="bold">
                {errorMes}
              </Text>
            </Col>
          ) : showSuccess ? (
            <Col alignCenter justifyCenter>
              <Text mb1 size={18} color={COLOR.GREEN} fontWeight="bold">
                Registration successful!
              </Text>
              <Text>You can now log in to your new account.</Text>
            </Col>
          ) : null}
        </Col>
      </Col>
    </Col>
  );
};

Register.routeInfo = {
  title: 'Register - MSC App',
  path: '/register',
};

export default Register;
